import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const ResetInvoiceForRetryMutation = graphql.persisted(
  "ResetInvoiceForRetry",
  graphql(`
    mutation ResetInvoiceForRetry($input: ResetInvoiceForRetryInput!) {
      resetInvoiceForRetry(input: $input) {
        success
        userErrors { message path }
      }
    }
  `)
);

export { ResetInvoiceForRetryMutation };

export function useResetInvoiceForRetry() {
  return useMutation(ResetInvoiceForRetryMutation);
}
